import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "block w-full mb-4" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_3 = { class: "inputTitle" }
const _hoisted_4 = { class: "inputField flex-grow" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "error-msg" }
const _hoisted_7 = { class: "inputTitle" }
const _hoisted_8 = { class: "inputField flex-grow" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "error-msg" }
const _hoisted_11 = { class: "inputTitle" }
const _hoisted_12 = { class: "inputField flex-grow" }
const _hoisted_13 = { class: "inputTitle" }
const _hoisted_14 = { class: "inputField flex-grow" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "error-msg" }
const _hoisted_17 = { class: "inputTitle" }
const _hoisted_18 = { class: "inputField flex-grow" }
const _hoisted_19 = { class: "error-msg" }
const _hoisted_20 = { class: "inputTitle" }
const _hoisted_21 = { class: "inputField flex-grow" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "error-msg" }
const _hoisted_24 = { class: "col-span-2" }
const _hoisted_25 = { class: "inputTitle" }
const _hoisted_26 = { class: "inputField flex-grow" }
const _hoisted_27 = { class: "flex flex-wrap" }
const _hoisted_28 = ["checked", "id", "value", "disabled", "onChange"]
const _hoisted_29 = { class: "inputTitle ml-2" }
const _hoisted_30 = ["for"]

import {computed, onMounted, ref, toRef} from "vue";
import {useSystemStore} from "@/stores/system/SystemStore";
import {email, helpers, numeric, required} from "@vuelidate/validators";
import {useI18n} from "vue-i18n";
import useVuelidate from "@vuelidate/core";
import {countryDialCodes} from "@/AppConfig";
import Select from "@/components/system/inputs/Select.vue";
import {User} from "@/models/entities/users/User";
import {Option} from "@/models/helpers/Option";
import {getVisibleRoles, isRoleDisabled} from "@/utilities/helpers/RoleHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddOrUpdateUserPopup',
  props: {
  data: Object
},
  setup(__props) {

const props = __props
const popupData = toRef(props, 'data');

const systemStore = useSystemStore();
const { t } = useI18n();

// Roles the current user is allowed to see / assign
const visibleRoles = computed(() => getVisibleRoles(systemStore.user?.roles ?? []));

// Check if a role is selected
const isRoleSelected = (role: Option) => {
  if (!popupData.value?.roles) return false;
  return (popupData.value as User).roles.includes(role.roleName);
}

// Toggle role selection
const toggleRole = (role: Option, checked: boolean) => {
  if (!popupData.value) return;
  if (isRoleDisabled(role.roleName)) return;
  
  const user = popupData.value as User;
  if (!user.roles) {
    user.roles = [];
  }
  
  if (checked) {
    // Add role if not already present
    if (!user.roles.includes(role.roleName)) {
      user.roles.push(role.roleName);
    }
  } else {
    // Remove role
    user.roles = user.roles.filter(r => r !== role.roleName);
  }
}

const selectedCountryDialCodes = computed(() => {
  if(popupData.value?.dialCode != "") {
    if(countryDialCodes.find(cw => cw.dialCode===popupData.value?.dialCode) != null) {
      return countryDialCodes.find(cw => cw.dialCode===popupData.value?.dialCode)?.id
    } else {
      return null
    }

  } else {
    return null
  }
})

const rules = computed(() => {
  const rules = {
    firstName: { required: helpers.withMessage(t('validators.required'), required) },
    lastName: { required: helpers.withMessage(t('validators.required'), required) },
    dialCode: { required: helpers.withMessage(t('validators.required'), required) },
    phoneNumber: {
      required: helpers.withMessage(t('validators.required'), required),
      numeric: helpers.withMessage(t('validators.phoneNumber'), numeric),
    },
    email: {
      required: helpers.withMessage(t('validators.required'), required),
      email: helpers.withMessage(t('validators.email'), email),
    },
  }
  return rules
})

const v$ = ref(useVuelidate(rules, popupData));

onMounted(()=>{
  systemStore.modal.validator = v$;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('userManagment.popups.addOrUpdate.firstname')) + " * ", 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.firstName.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((popupData.value.firstName) = $event)),
                class: "w-full",
                id: "firstName"
              }, null, 512), [
                [_vModelText, popupData.value.firstName]
              ]),
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.firstName.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('userManagment.popups.addOrUpdate.lastname')) + " * ", 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.lastName.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popupData.value.lastName) = $event)),
                class: "w-full",
                id: "lastName"
              }, null, 512), [
                [_vModelText, popupData.value.lastName]
              ]),
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.lastName.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('userManagment.popups.addOrUpdate.ssoIdentifier')), 1),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((popupData.value.ssoIdentifier) = $event)),
              class: "w-full",
              id: "ssoIdentifier"
            }, null, 512), [
              [_vModelText, popupData.value.ssoIdentifier]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('userManagment.popups.addOrUpdate.email')) + " * ", 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.email.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((popupData.value.email) = $event)),
                class: "w-full",
                id: "email"
              }, null, 512), [
                [_vModelText, popupData.value.email]
              ]),
              _hoisted_15,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.email.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('userManagment.popups.addOrUpdate.dialCode')) + " * ", 1),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.dialCode.$errors.length })
            }, [
              _createVNode(Select, {
                options: _unref(countryDialCodes),
                class: "w-full",
                mode: "single",
                selected: selectedCountryDialCodes.value,
                searchable: true,
                onSelectChanged: _cache[4] || (_cache[4] = (value)=>{popupData.value.dialCode = _unref(countryDialCodes).find(cw => cw.id===value).dialCode}),
                id: "dialCode"
              }, null, 8, ["options", "selected"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.dialCode.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('userManagment.popups.addOrUpdate.phoneNumber')) + " * ", 1),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.phoneNumber.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((popupData.value.phoneNumber) = $event)),
                class: "w-full",
                id: "phoneNumber"
              }, null, 512), [
                [_vModelText, popupData.value.phoneNumber]
              ]),
              _hoisted_22,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.phoneNumber.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('userManagment.popups.addOrUpdate.roles')), 1),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoles.value, (role) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: role.id,
                  class: "inputField flex w-1/3"
                }, [
                  _createElementVNode("input", {
                    checked: isRoleSelected(role),
                    type: "checkbox",
                    id: `role-${role.id}`,
                    value: role.roleName,
                    disabled: _unref(isRoleDisabled)(role.roleName),
                    onChange: (e) => toggleRole(role, (e.target as HTMLInputElement).checked)
                  }, null, 40, _hoisted_28),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", {
                      for: `role-${role.id}`
                    }, _toDisplayString(_unref(t)(`general.roles.${role.roleName}`)), 9, _hoisted_30)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})